import logo from './logo.svg';
//import mylogo from './Pics/TeknicalMage_OnHover_Logo.png';
//<img src={mylogo} className="My-logo" alt="logo" />
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        
        <br></br>
        <br></br>
        <br></br>

        <p className='killme'>
        Large scale problem solving for small scale communities 
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          
        </a>
      </header>
    </div>
  );
}

export default App;


